module.exports = __webpack_public_path__ + "static/media/2023_27.7652b3b6.jpg";